import React, { useState } from "react";
import { Button } from "antd";
import { ZoomInOutlined, ZoomOutOutlined } from "@ant-design/icons";
import { useCanvas } from "../../context/canvasContext";
import "./styles.css";

const ZoomInZoomOut = () => {
  const { canvasRef } = useCanvas();
  const [zoomLevel, setZoomLevel] = useState(100);

  const handleZoom = (zoomIn = true) => {
    if (!canvasRef?.current) return;
    const canvas = canvasRef.current;
    let newZoom = zoomIn ? zoomLevel + 8 : zoomLevel - 8; 
    if (newZoom < 8 || newZoom > 300) return; 
    const center = canvas.getCenter();
    canvas.zoomToPoint({ x: center.left, y: center.top }, newZoom / 100);
    setZoomLevel(newZoom);
  };

  return (
    <div className="zoom-container">
      <Button
        type="ghost"
        shape="circle"
        icon={<ZoomOutOutlined />}
        onClick={() => handleZoom(false)}
        onMouseDown={(e) => e.currentTarget.blur()}
        onBlur={(e) => e.currentTarget.blur()}
      />

      <span className="zoom-percentage">{zoomLevel}%</span>

      <Button
        type="ghost"
        shape="circle"
        icon={<ZoomInOutlined />}
        onClick={() => handleZoom(true)}
        onMouseDown={(e) => e.currentTarget.blur()}
        onBlur={(e) => e.currentTarget.blur()}
      />
    </div>
  );
};

export default ZoomInZoomOut;
